import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Button } from 'reactstrap';
import RFField from '../../../components/Form/RFField';

const portal = document.createElement('div');
portal.classList.add('my-super-cool-portal');

if (!document.body) {
  throw new Error('body not ready for portal creation!');
}

document.body.appendChild(portal);

class AllapotItem extends Component {
  render() {
    const {
      provided,
      snapshot,
      text,
      deleteItem,
      id,
      bgColor,
      textColor,
      loading,
      emailKuldes,
      emailKuldesChange,
      options
    } = this.props;

    const usePortal = snapshot.isDragging;

    const child = (
      <div
        style={{ marginBotton: 10 }}
        className={snapshot.isDragging ? 'card text-white bg-primary dnd-list select-item-border' : 'card bg-light dnd-list'}
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
      >
        <div
          className="card-body"
          style={loading ? {
            padding: 10,
            backgroundColor: bgColor,
            backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(255,255,255,.5) 10px, rgba(255,255,255,.5) 20px)'
          } : {
            padding: 10,
            backgroundColor: '#' + bgColor,
            color: textColor
          }}
        >
          <div className="row">
            <div className="col-md-7">
              {text}
            </div>
            <div className="col-md-5">
              <RFField
                // label="Email küldés:"
                type="select"
                name={"emailKuldes" + id }
                value={emailKuldes}
                // defaultSelect={<option style={{ backgroundColor: '#' + bgColor, color: textColor }}value='' disabled>Válassz értéket...</option>}
                selectOptions={options.map(e => <option style={{ backgroundColor: 'transparent', color: textColor }} key={e.name} value={e.name}>{e.caption}</option>)}
                style={{ backgroundColor: '#' + bgColor, color: textColor }}
                // onClick={() => {emailKuldesChange(id);}}
                onChange={(e) => emailKuldesChange(e, id)}
              />
              {loading ? ' mentés...' : ''}
            </div>
          </div>
          <span>
            {deleteItem && <Button
              className="icon-trash table-action-icon pull-right allapot-icon"
              type="button"
              style={{ border: 0, backgroundColor: 'transparent', cursor: 'pointer', color: textColor, padding: 4 }}
              onClick={() => {
                deleteItem(id);
              }}
            />}
          </span>
        </div>
      </div>
    );

    if (!usePortal) {
      return child;
    }

    // if dragging - put the item in a portal
    return ReactDOM.createPortal(child, portal);
  }
}

export default AllapotItem;
